import * as React from "react";
import { useParams } from "react-router-dom";
import { useGetAgentInfoQuery, useGetAgentQuery } from "../../store/api/agentApi";
import { AGENT_UPDATE_INTERVAL_MS } from "../../envVariables";
import { AgentDetailForm } from "./detailForm";
import { Loader } from "../../components/layout/loader";
import { IncorrectItem } from "../../components/generic/IncorrectItem/incorrectItem";
import { AccessRestrictedItem } from "../../components/generic/AccessRestrictedItem/accessRestrictedItem";

type RouteParams = "org" | "agent";
export const AgentDetailInitializer: React.FC = () => {
  const { org: orgName, agent: agentName } = useParams<RouteParams>();

  const selfLink = `/org/${orgName}/agent/${agentName}`;

  const { data: agent, isLoading, isFetching, isError, error, refetch } = useGetAgentQuery(selfLink, {
    skip: !selfLink,
    refetchOnMountOrArgChange: true,
  });

  const { data: agentInfo, isError: isInfoError } = useGetAgentInfoQuery(selfLink || "", {
    skip: !selfLink,
    pollingInterval: AGENT_UPDATE_INTERVAL_MS,
  });

  React.useEffect(() => {
    if (isInfoError) {
      refetch();
    }
  }, [isInfoError, refetch]);

  if (!agent && isLoading) {
    return <Loader />;
  }

  const is403 = isError && (error as any)?.status === 403;
  if (is403) {
    return <AccessRestrictedItem kind="agent" />;
  }

  const is404 = isError && (error as any)?.status === 404;
  if (is404 || !agent) {
    return <IncorrectItem kind="agent" canCreate={true} />;
  }

  return <AgentDetailForm agent={agent} agentInfo={agentInfo} />;
};
